import Cog from '@motional/inguitiv/svg/icon/cog.svg?react';

function Icon() {
  return <Cog />;
}

export default Icon;
